<template>
  <div class="chart-one">
    <div class="box">
      <h1>国内机构网络设施风险监测与评分</h1>
      <div class="pie3d" ref="pie3d" />
      <div class="labelScore">
          <div v-for="(item,index) in this.trueList" :key="index" class="legend-item">
              <div class="color-square" :style="{'backgroundColor': colorList[index]}"></div>
              <div class="name" >
                  {{item.name}}
              </div>
              <div class="score" >
                  {{item.score}}
              </div>
          </div>

      </div>
      <div class="background">
        <img src="../../assets/PlatformOverview/aperture.png" alt="">
      </div>


      <!-- 射线 -->
      <div class="shexian">
        <div class="ray-container">
          <div class="ray">
            <img src="@assets/PlatformOverview/line.png" alt="">
          </div>
          <div class="wu">
            <img src="@assets/PlatformOverview/wu.png" alt="">
          </div>

          <div class="particle-container" ref="particleContainer">

          </div>
        </div>
      </div>
      <!--小球-->
      <div class="ball-container">
        <transition-group name="ball">
          <!-- 使用transition-group来包裹小球，实现多个小球的动画效果 -->
          <div v-for="(ball, index) in balls" :key="index" class="ball" ref="ball"
               :style="{ left: ball.left + 'px', bottom: ball.bottom + 'px', width: ball.size + 'px', height: ball.size + 'px' }">
            <!-- 小球的样式和位置随机生成 -->
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less">
.chart-one {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 247px;
  border-radius:10px ;
  color: rgba(255, 255, 255, 1);
}
.box {
  position: relative;
}
.pie3d{
  //position: absolute;
  //left: 0;
  //top: 0;
  width: 400px;
  height: 300px;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}
img{
  width: 100%;
}
.background{
  width: 250px;
  position: absolute;
  left: 6%;
  top: 46%;
  z-index: -2;
}
.shexian{
  width: 237px;
  position: absolute;
  height: 100px;
  display: flex;
  left: 7%;
  top: 17%;
  .wu{
    width: 237px;
    position: absolute;
    left: -1%;
    top: 34%;
  }
  .ray {
    position: absolute;
    //bottom: -40px;
    animation:play1 1s infinite;
  }
}
.labelScore{
  position: absolute;
  top:19%;
  right: 12px;
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 15px;
    .legend-item {
        display: flex;
        align-items: center;
        height: 24px;
    }
    .color-square {
        width: 14px;
        height: 14px;
        background-color: pink;
        margin-right: 5px;
    }
    .name {
        font-family: 'SourceHanSansCN';
        font-size: 13px;
    }
  .score{
    margin-left: 5px;
  }
}
@keyframes play1 {
  0% {
    bottom: 65px;
    opacity: 1;
    height: 0;
  }
  100% {
    bottom: 100px;
    height: 10px;
    opacity: 0;
  }
}
.ball-container {
  position: absolute;
  left: 9%;
  top: 17%;
  width: 235px;
  height: 140px; /* 盒子的高度 */
  overflow: hidden;
  //background-color: rgba(2,2,2,0.4);
}

.ball {
  position: absolute;
  background-color: rgba(255,255,255,0.8);
  border-radius: 50%; /* 小球圆形 */
  animation: rise 2.5s infinite linear; /* 小球上升动画 */
}

@keyframes rise {
  0% {
    top:100%;
    opacity: 1;
  }
  75% {
    top:55%;
    opacity: 0.6;
  }
  100% {
    top:15%;
    opacity: 0;
  }
}
</style>
<script >
// import * as echarts from 'echarts';
import "echarts-gl";
import {getInstitutionalFacilities} from "@/service/dashboard";

export default {
  name: "ParticleEmitter",
  data(){
    return {
      colorList: ["rgb(122, 112, 255)","rgb(75, 223, 255)","rgb(126, 233, 255)","rgb(86, 120, 255)",
        "rgb(227, 255, 255)","rgb(96, 250, 204)"],
      balls: [], // 存储生成的小球信息
      optionData: [
        {
          code: "0",
          name: "清华大学",
          value:72,
          // startRatio: 0.34782608695652173,
          // endRatio: 0.6086956521739131,
          itemStyle: {
            color: "rgba(122, 112, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "1",
          name: "南开大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 54,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(75, 223, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "2",
          name: "北京大学",
          cws: 50,
          zcs: 20,
          zcl: "40%",
          value: 35,
          startRatio: 0.6086956521739131,
          endRatio: 0.8260869565217391,
          itemStyle: {
            color: "rgba(126, 233, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "3",
          name: "东北大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 35,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(79, 179, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "4",
          name: "理工大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 35,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(107, 255, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "5",
          name: "南京大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 35,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(86, 120, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "6",
          name: "开封大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 24,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(227, 255, 255, 1)",
            opacity: "1"
          }
        },
        {
          code: "6",
          name: "长安大学",
          cws: 40,
          zcs: 30,
          zcl: "75%",
          value: 13,
          startRatio: 0.8260869565217391,
          endRatio: 1,
          itemStyle: {
            color: "rgba(96, 250, 204, 1)",
            opacity: "1"
          }
        }
      ]
    };
  },
  mounted() {
    this.myChart = this.$echarts.init(this.$refs.pie3d);
    this.getData();
    this.init();
    // 在组件挂载后开始生成小球
    this.generateBalls();
  },
  computed: {
    trueList() {
      return this.optionData.filter((item, index, self) => {
        return index === self.findIndex((t) => t.name === item.name);
      }).sort((a,b) => b.score - a.score);
    }
  },
  methods: {
    uniqueByName(arr) {
      let uniqueNames = new Set();

      return arr.filter((item) => {
        let isUnique = !uniqueNames.has(item.name);

        uniqueNames.add(item.name);
        return isUnique;
      });
    },
    sortByScoreDescending(items) {
      return items.sort((a, b) => b.score - a.score);
    },
    getData(){
      getInstitutionalFacilities().then(res => {
        //返回值排序
        this.optionData = res.map(item =>{
          return {
            ...item,
            name : item.name,
            value : item.score,
            type: item.type
          };
        });
        this.init();
        this.sortByScoreDescending(this.optionData);
      });
    },
    generateBalls() {
      // 定时生成小球
      setInterval(() => {
        const size = Math.floor(Math.random() * 2)+2 ; // 随机生成小球大小
        const left = Math.random() * (this.$el.clientWidth - size); // 随机生成小球横坐标
        const bottom = 0; // 小球初始纵坐标在底部
        // const duration = Math.random() * 3000 + 5000; // 随机生成小球运动持续时间

        this.balls.push({ size, left, bottom });

        setTimeout(() => {
          this.balls.splice(0, 1);
        }, 1400);
      }, 400); // 每隔一段时间生成一个小球
    },
    // 初始化构建
    init() {
      // 传入数据生成 option ; getPie3D(数据，透明的空心占比（调节中间空心范围的0就是普通饼1就很镂空）)
      this.option = this.getPie3D(this.optionData, 0.8);
      // 将配置项设置进去
      this.myChart.setOption(this.option);
      window.onresize = () => {
        setTimeout(() => {
          const width = this.$refs.pie3d.offsetWidth;
          const height = this.$refs.pie3d.offsetHeight;

          this.myChart.resize({
            width: width,
            height: height
          });
        }, 50);
      };
    },
    getPie3D(pieData, internalDiameterRatio) {
      const that = this;
      const series = [];

      let sumValue = 0;

      let startValue = 0;

      let endValue = 0;

      let legendData = [];

      let legendBfb = [];
      const k = 1 - internalDiameterRatio;

      pieData.sort((a, b) => (b.value - a.value));
      // 为每一个饼图数据，生成一个 series-surface(参数曲面) 配置
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < pieData.length; i++) {
        sumValue += pieData[i].value;
        const seriesItem = {
          // 系统名称
          name: typeof pieData[i].name === "undefined" ? `series${i}` : pieData[i].name,
          type: "surface",
          // 是否为参数曲面（是）
          parametric: true,
          // 曲面图网格线（否）上面一根一根的
          wireframe: {
            show: false
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k
          }
        };
        // 曲面的颜色、不透明度等样式。

        if (typeof pieData[i].itemStyle !== "undefined") {
          const itemStyle = {};
          // eslint-disable-next-line no-unused-expressions

          typeof pieData[i].itemStyle.color !== "undefined" ? itemStyle.color = pieData[i].itemStyle.color : null;
          // eslint-disable-next-line no-unused-expressions
          typeof pieData[i].itemStyle.opacity !== "undefined" ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      legendData = [];
      legendBfb = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < series.length; i++) {
        endValue = startValue + series[i].pieData.value;
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          series[i].pieData.value
        );
        startValue = endValue;
        const bfb = that.fomatFloat(series[i].pieData.value / sumValue, 4);

        legendData.push({
          name: series[i].name,
          value: bfb
        });
        legendBfb.push({
          name: series[i].name,
          value: bfb
        });
      }
      // (第二个参数可以设置你这个环形的高低程度)
      const boxHeight = this.getHeight3D(series, 53);// 通过传参设定3d饼/环的高度
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      const option = {
        // 图例组件
        legend: {
          data: legendData,
          // 图例列表的布局朝向。
          orient: "vertical",
          right: "3%",
          top: "19%", // 垂直方向位置
          itemWidth: 13,        // 图例图标的宽度
          itemHeight: 13,       // 图例图标的高度，与宽度相同以创建正方形
          // 图例文字每项之间的间隔
          itemGap:5,
          textStyle: {
            color:"rgba(241, 237, 255, 1)",
            fontSize:"12"
          },
          show: false,
          icon: "rect"
        },
        // 移动上去提示的文本内容
        tooltip: {
          show: true,
          // eslint-disable-next-line consistent-return
          formatter: (params) => {
            if (params.seriesName !== "mouseoutSeries" && params.seriesName !== "pie2d") {
              // eslint-disable-next-line max-len
              const bfb = ((option.series[params.seriesIndex].pieData.endRatio - option.series[params.seriesIndex].pieData.startRatio)
                  * 100).toFixed(2);

              return `${params.seriesName}<br/>`
                  + `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>`
                  + `${bfb}`;
            }
          }
        },
        // 这个可以变形
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        // 此处是修改样式的重点
        grid3D: {
          show: false,
          boxHeight, // 圆环的高度
          // 这是饼图的位置
          left: "-12.5%",
          top: "1.8%",
          viewControl: { // 3d效果可以放大、旋转等，请自己去查看官方配置
            alpha: 12, // 角度(这个很重要 调节角度的)
            distance: 260, // 调整视角到主体的距离，类似调整zoom(这是整体大小)
            rotateSensitivity: 0, // 设置为0无法旋转
            zoomSensitivity: 0, // 设置为0无法缩放
            panSensitivity: 0, // 设置为0无法平移
            autoRotate: false // 自动旋转
          }
        },
        series
      };

      return option;
    },
    getHeight3D(series, height) {
      series.sort((a, b) => (b.pieData.value - a.pieData.value));
      // eslint-disable-next-line no-mixed-operators
      return height * 25 / series[0].pieData.value;
    },
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      const midRatio = (startRatio + endRatio) / 2;
      const startRadian = startRatio * Math.PI * 2;
      const endRadian = endRatio * Math.PI * 2;
      const midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。

      if (startRatio === 0 && endRatio === 1) {
        // eslint-disable-next-line no-param-reassign
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      // eslint-disable-next-line no-param-reassign
      k = typeof k !== "undefined" ? k : 1 / 3;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      const hoverRate = isHovered ? 1.05 : 1;
      // 返回曲面参数方程

      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x(u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y(u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z(u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1;
          }
          return Math.sin(v) > 0 ? Number(h) * 0.1 : -1;
        }
      };
    },
    fomatFloat(num, n) {
      let f = parseFloat(num);
      // eslint-disable-next-line no-restricted-globals

      if (isNaN(f)) {
        return false;
      }
      // eslint-disable-next-line prefer-exponentiation-operator, no-restricted-properties
      f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
      let s = f.toString();

      let rs = s.indexOf(".");
      // 判定如果是整数，增加小数点再补0

      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + n) {
        s += "0";
      }
      return s;
    }
  }
};
</script>

